import {
  GET_SHIPPING_CASES,
  SET_SHIPPING_CASES,
  SET_SHIPPING_ORDER,
  SET_SHIPPING_ORDER_BY,
  SET_SHIPPING_PAGE,
  SET_SHIPPING_ROWS_PER_PAGE,
  SET_SHIPPING_SEARCH,
  SET_SHIPPING_ACTIVE_TAB,
} from './actionTypes';

// import { getHospitals } from './hospitalsActions';
import { getSetsAllocation } from './casesActions';

import firebase from '../firebase';

// import { territoryRoles, roleNames } from '../constants/userRoles';
import { post } from '../utils/api';
import urls from '../constants/urls';
import { territoryRoles } from '../constants/userRoles';
import { getHospitals } from './hospitalsActions';

// const { ADMIN, OPERATIONS, CUSTOMER_SERVICE, LOGISTICS, SALES_MANAGER, MARKETING, FINANCE } = roleNames;

export const getCases = (queryParams) => async (dispatch, getState) => {
  const params = { ...queryParams };
  const state = getState();
  const tenantId = state.tenant.currentTenant ? state.tenant.currentTenant.id : null;
  const currentUser = state.user.currentUser;
  let hospitals = state.hospitals?.list || [];

  dispatch({ type: GET_SHIPPING_CASES });

  const idToken = await firebase.auth.currentUser.getIdToken();

  if (tenantId) {
    if (territoryRoles?.includes(currentUser.role) && !!currentUser.territoryVisibility) {
      if (!hospitals?.length) {
        const hospitalsRes = await dispatch(getHospitals());
        hospitals = hospitalsRes?.hospitals || [];
      }

      const userHospitals = hospitals?.filter((h) => h.territories?.some((territory) => currentUser?.assignedTerritories?.includes(territory)));
      const territories = [];

      userHospitals.forEach((hospital) => {
        hospital?.territories?.forEach((territory) => {
          if (!territories.includes(territory)) {
            territories.push(territory);
          }
        });
      })

      params.territories = territories?.length ? territories : ['empty'];
    }

    const res = await post(urls.cases.get(tenantId), { params: { ...params, tenantId, hasSetsAllocation: true } }, idToken);

    if (res && res.cases) {
      const promises = res.cases?.map(async (doc) => {
        const setsAllocation = await dispatch(getSetsAllocation(doc.caseId, true));

        return {
          ...doc,
          id: doc.caseId,
          setsAllocation: setsAllocation || [],
          usage: [],
          // createdAt: doc && doc.createdAt ? doc.createdAt.toDate() : '',
          // updatedAt: doc && doc.updatedAt ? doc.updatedAt.toDate() : '',
          // date: doc && doc.date ? doc.date.toDate() : '',
          // orderClosedAt: doc && doc.orderClosedAt ? doc.orderClosedAt.toDate() : '',
          // proformaSentAt: doc && doc.proformaSentAt ? doc.proformaSentAt.toDate() : '',
          // proformaDate: doc && doc.proformaDate ? doc.proformaDate.toDate() : '',
          // collectionDate: doc && doc.collectionDate ? doc.collectionDate.toDate() : '',
          // returnDate: doc && doc.returnDate ? doc.returnDate.toDate() : '',
        };
      });

      const cases = await Promise.all(promises);
      return {
        cases,
        total: res.total,
      }
    }
  } else {
    throw new Error('Invalid tenant');
  }

  // let query;
  // let docs = [];
  //
  // if ([ADMIN, OPERATIONS, CUSTOMER_SERVICE, LOGISTICS, SALES_MANAGER, MARKETING, FINANCE].includes(currentUser.role)) {
  //   query = firebase
  //     .db
  //     .collection(path)
  //
  //   const snapshot = await query.get();
  //   docs = snapshot?.docs;
  // } else {
  //   if (!currentUser.assignedSurgeons || !currentUser.assignedSurgeons.length) {
  //     return dispatch(setCases([]));
  //   }
  //
  //   const assignedSurgeons = currentUser.assignedSurgeons || ['empty'];
  //   const chunks = chunkArray(assignedSurgeons);
  //   const snapshots = [];
  //
  //   for await (const snap of chunks?.map(
  //     async (chunk) =>
  //       await firebase
  //         .db
  //         .collection(path)
  //         .where('surgeon', 'in', chunk)
  //         .get()
  //   )) {
  //     snapshots?.push(snap);
  //   }
  //
  //   let temp = [];
  //   snapshots?.forEach((snap) => {
  //     temp = [...temp, ...snap?.docs];
  //   });
  //   docs = temp;
  // }
  //
  // if (territoryRoles?.includes(currentUser.role) && !!currentUser.territoryVisibility) {
  //   const hospitals = state.hospitals?.list?.length ? state.hospitals?.list : await dispatch(getHospitals(tenantId));
  //   const userHospitals = hospitals?.filter((h) => h.territories?.some((territory) => currentUser?.assignedTerritories?.includes(territory)));
  //   docs = docs?.filter((item) => userHospitals?.map((h) => h.id)?.includes(item?.data()?.hospital));
  // }
  //
  // const cases = docs?.map((doc) => {
  //   const data = doc.data();
  //   return {
  //     ...data,
  //     id: doc.id,
  //     createdAt: data && data.createdAt ? data.createdAt.toDate() : '',
  //     updatedAt: data && data.updatedAt ? data.updatedAt.toDate() : '',
  //     date: data && data.date ? data.date.toDate() : '',
  //     setsAllocation:  [],
  //     proformaSentAt: data && data.proformaSentAt ? data.proformaSentAt.toDate() : '',
  //     proformaDate: data && data.proformaDate ? data.proformaDate.toDate() : '',
  //     collectionDate: data && data.collectionDate ? data.collectionDate.toDate() : '',
  //   };
  // }) || [];
  //
  // const concurrencyLimit = 200;
  // for (let i = 0; i < cases.length; i += concurrencyLimit) {
  //   const batch = cases.slice(i, i + concurrencyLimit);
  //   await Promise.all(
  //     batch.map(async (caseItem) => {
  //       const setsAllocation = await dispatch(getSetsAllocation(caseItem.id, true));
  //       if (setsAllocation?.length) {
  //         caseItem.setsAllocation = setsAllocation;
  //       }
  //     })
  //   );
  // }
  //
  // const filteredCases = cases.filter((item) => !!item.setsAllocation.length);
  // return dispatch(setCases(orderBy(filteredCases, 'date', 'asc')));
};

export const setCases = (cases) => ({ type: SET_SHIPPING_CASES, cases });

export const setOrder = (value) => ({ type: SET_SHIPPING_ORDER, value });

export const setOrderBy = (value) => ({ type: SET_SHIPPING_ORDER_BY, value });

export const setPage = (value) => ({ type: SET_SHIPPING_PAGE, value });

export const setRowsPerPage = (value) => ({ type: SET_SHIPPING_ROWS_PER_PAGE, value });

export const setSearch = (value) => ({ type: SET_SHIPPING_SEARCH, value });

export const setActiveTab = (value) => ({ type: SET_SHIPPING_ACTIVE_TAB, value });